import { useDispatch } from 'react-redux';
import { handleAPIError } from 'utils/handleErrors';
import { setUserNotVerifiedRestricted } from '../slices/generalData/generalData';

export function useHandleResponse() {
  const dispatch = useDispatch();

  const handleResponse = (response, onSuccess) => {
    // console.log('handleResponse recibio:', response);

    if (!response) return;

    // Caso status 206
    if (response.status === 206) {
      dispatch(setUserNotVerifiedRestricted(true));
      return;
    }

    // Caso error
    if (response.error) {
      handleAPIError(response);
      return;
    }

    // Caso éxito
    if (typeof onSuccess === 'function') {
      onSuccess(response);
    }
  };

  return { handleResponse };
}
